import { render, staticRenderFns } from "./OldInputFile.vue?vue&type=template&id=64b73956&scoped=true"
import script from "./OldInputFile.vue?vue&type=script&lang=js"
export * from "./OldInputFile.vue?vue&type=script&lang=js"
import style0 from "./OldInputFile.vue?vue&type=style&index=0&id=64b73956&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b73956",
  null
  
)

export default component.exports